
const style = {
    flexGrow: 1
};

export function Grow() {

  return (
    <div style={style} />
  );
}